import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TopBar from "./TopBar";
import MainNavbar from "./MainNavbar";
import SiteFooter from "./SiteFooter";
import { authService, catalogService } from "../services";
import "../assets/css/lucid.css";

// โครงหลักของทุกหน้า: TopBar + Navbar + ประกาศ + เนื้อหา + Footer
export default function Layout({ children, announce = false }) {
  const navigate = useNavigate();
  const [profile, setProfile] = useState(authService.currentProfile());
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    const sync = () => setProfile(authService.currentProfile());
    window.addEventListener("storage", sync);
    window.addEventListener("lt-auth-change", sync);
    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener("lt-auth-change", sync);
    };
  }, []);

  useEffect(() => {
    if (!announce) return;
    let alive = true;
    catalogService.announcements().then((rows) => alive && setAnnouncements(rows || []));
    return () => {
      alive = false;
    };
  }, [announce]);

  const handleLogout = async () => {
    await authService.logout();
    window.dispatchEvent(new Event("lt-auth-change"));
    navigate("/login");
  };

  return (
    <div className="lucid-app">
      <TopBar profile={profile} onLogout={handleLogout} />
      <MainNavbar profile={profile} onLogout={handleLogout} />

      <main className="lucid-app__body">
        {announce && announcements.length ? (
          <div className="lt-announce">
            <div className="lt-announce__track">
              {[...announcements, ...announcements].map((text, index) => (
                <span key={index}>{text}</span>
              ))}
            </div>
          </div>
        ) : null}
        {children}
      </main>

      <SiteFooter />

      <button type="button" className="lt-chat-fab" title="ติดต่อทีมงาน" onClick={() => window.open("mailto:lucidtopup@gmail.com", "_blank")}>
        💬
      </button>
    </div>
  );
}
